import { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";

import StoreStateModel from "../../Models/store";

import PopUpSelector from "./PopUp";
import { getAccountAssigned } from "../../API/apiAuth";
import { Response } from "../../Models/api";
import { InternalAccountAssignedModel } from "../../Models/account";
import { updateAccountAssigned } from "../../../../store/actions";

interface Props {
  hasPermissionSupportOperatorWrite: boolean;
  hasPermissionShippingWrite: boolean;
}

const AccountSelector = ({
  hasPermissionSupportOperatorWrite,
  hasPermissionShippingWrite,
}: Props) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [openPopUp, setOpenPopUp] = useState(false);

  const accountAssigned = useSelector(
    (state: StoreStateModel) => state.auth.accountAssigned,
    shallowEqual
  );

  useEffect(() => {
    verifyAccount();
  }, []);

  const verifyAccount = async () => {
    try {
      const response: Response = await getAccountAssigned();
      if (!response.data.hasErrors) {
        const tempAccount = response.data.payload;
        if (tempAccount) {
          dispatch(
            updateAccountAssigned({
              name: tempAccount.accountName,
              id: tempAccount.activingAccountId,
            } as InternalAccountAssignedModel)
          );
        } else {
          dispatch(
            updateAccountAssigned({
              name: "",
              id: 0,
            } as InternalAccountAssignedModel)
          );
        }
      } else {
        dispatch(
          updateAccountAssigned({
            name: "",
            id: 0,
          } as InternalAccountAssignedModel)
        );
      }
    } catch (error) {
      dispatch(
        updateAccountAssigned({
          name: "",
          id: 0,
        } as InternalAccountAssignedModel)
      );
    }
  };

  const label = accountAssigned && accountAssigned.id > 0 ? "Change" : "Select Account";
  const accountLable =
    accountAssigned && accountAssigned.id > 0
      ? accountAssigned.name + " (" + accountAssigned.id + ") "
      : null;
  return (
    <Grid container alignItems="center" justifyContent="center">
      <Typography sx={{ color: theme.palette.text.secondary }}>
        {accountAssigned && accountAssigned.id > 0 ? accountLable : ""}
      </Typography>
      {(hasPermissionSupportOperatorWrite || hasPermissionShippingWrite) && (
        <Button
          size="small"
          variant={"outlined"}
          sx={{
            ml: 2,
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
          }}
          onClick={() => setOpenPopUp(true)}
        >
          {label}
        </Button>
      )}
      <PopUpSelector open={openPopUp} buttonLabel={label} onClose={() => setOpenPopUp(false)} />
    </Grid>
  );
};

export default AccountSelector;
